
import React from 'react';
import { Button } from '@/components/ui/button';

interface DataSourcesHeaderProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const DataSourcesHeader: React.FC<DataSourcesHeaderProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  return (
    <div className="flex flex-col space-y-1.5">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-2xl font-semibold leading-none tracking-tight">Data Sources</h3>
          <p className="text-sm text-muted-foreground mt-1">
            Manage your data sources, ETL pipelines, and data ingestion settings
          </p>
        </div>
        <div className="flex gap-2">
          {editing ? (
            <Button variant="default" onClick={onSave}>
              Save Changes
            </Button>
          ) : (
            <Button variant="outline" onClick={onEditToggle}>
              Edit Settings
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataSourcesHeader;
